import { EMPTY_LIST } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { NotificationInline } from '../NotificationInline'

import { getSortedNotifications } from './NotificationInlineList.utils'

import * as styles from './NotificationInlineList.module.css'

function NotificationInlineList({
  className = styles.NotificationInlineList,
  items = EMPTY_LIST,
  notificationClassName,
  qaName,
  ref,
  sortItems = getSortedNotifications,
}) {
  const sortedItems = sortItems(items)

  const qaProps = getQaSelector({ value: qaName })

  return (
    <div {...qaProps} className={className} ref={ref}>
      {sortedItems.map(notification => (
        <NotificationInline
          {...notification}
          className={notificationClassName}
          key={notification.text}
        />
      ))}
    </div>
  )
}

export default NotificationInlineList
